import { ButtonBase } from "@material-ui/core";
import styled from "styled-components";

export const SelectButtonBase = styled(ButtonBase)`
  width: 100%;
  padding: 0.25rem 0.5rem;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border: ${({ theme }) => `1px solid ${theme.palette.border.main}`};
  border-radius: ${({ theme }) => `${0.66 * theme.shape.borderRadius}px`};
  &:disabled {
    background-color: ${({ theme }) => theme.palette.disabled.light};
    cursor: not-allowed;
  }
`;
